import { Box, Link } from '@mui/material';

import { attachCurrentQueryParams } from '@widget/utils/attachCurrentQueryParams';

import type { FC } from 'react';

export type LogoType = {
  image: Partial<{ name: string; filename: string; alt: string }>;
  url: Partial<{ url: string }>;
  width?: unknown;
  height?: unknown;
};

export type LogoProps = {
  logo: LogoType;
};

export const Logo: FC<LogoProps> = ({ logo }) => {
  return (
    <Box mr={3} flex="0 0 auto">
      <Link
        href={attachCurrentQueryParams(logo.url.url)}
        underline={'none'}
        sx={{
          display: 'block',
          lineHeight: 0,
        }}
      >
        <img
          src={logo.image.filename}
          width={logo.width as string}
          height={logo.height as string}
          alt={logo.image.alt || 'logo'}
        />
      </Link>
    </Box>
  );
};
